import React, { useState } from 'react';
import { t } from 'i18next';
import TabMenu from '../util/TabMenu';
import HrLeaveTypeSettings from './settings/HrLeaveTypeSettings';
import HrPublicHolidaySettings from './settings/HrPublicHolidaySettings';
import HrGeneralSettings from './settings/HrGeneralSettings';
import HrWorkingPatterns from './settings/HrWorkingPatterns';
import HrWorkingStatusSettingsNew from '../settingsComponents/HrWorkingStatusSettingsNew';
import Department from '../usersComponents/Department';
import HrProfileFields from '../settingsComponents/HrProfileFields';

interface Props { onClose?: () => void; embedded?: boolean; defaultTab?: string; }

const HrSettingsDrawer: React.FC<Props> = ({ defaultTab }) => {
  const [tab, setTab] = useState(defaultTab || 'general');

  return (
    <div className="text-[var(--text-color)]">
      <TabMenu
        value={tab}
        onChange={(v: string) => setTab(v)}
        tabs={[
          { label: t('HrAbsence') || 'Absence', value: 'general' },
          { label: t('HrWorkingPatterns'),  value: 'patterns' },
          { label: t('HrHolidays') || 'Holidays', value: 'holidays' },
          { label: t('Department') || 'Departments',   value: 'departments' },
          { label: t('HrUserProfile') || 'Profile',    value: 'profile' },
        ]}
      >
        <div style={{ flex: 1 }}>
          {tab === 'general' && (
            <>
              <HrGeneralSettings />
              <hr style={{ margin: 'var(--space-l2) 0', border: 'none', borderTop: '1px solid var(--border-input)' }} />
              <p className="text-[12px] font-semibold text-[var(--text-color-calendar-week)] uppercase tracking-wide mb-2">{t('HrStatuses') || 'Statuses'}</p>
              <div className="dt-card-wrap" style={{ overflow: 'hidden' }}><HrWorkingStatusSettingsNew /></div>
              <hr style={{ margin: 'var(--space-l2) 0', border: 'none', borderTop: '1px solid var(--border-input)' }} />
              <p className="text-[12px] font-semibold text-[var(--text-color-calendar-week)] uppercase tracking-wide mb-2">{t('HrLeaveTypes') || 'Leave Types'}</p>
              <HrLeaveTypeSettings />
            </>
          )}
          {tab === 'patterns'     && <HrWorkingPatterns />}
          {tab === 'holidays'     && <HrPublicHolidaySettings />}
          {tab === 'departments'  && <div className="dt-card-wrap" style={{ overflow: 'hidden' }}><Department /></div>}
          {tab === 'profile'      && <HrProfileFields />}
        </div>
      </TabMenu>
    </div>
  );
};

export default HrSettingsDrawer;
